/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_Hero_LeadInputs */

const es_gift_hero_lead = /** @type {(inputs: Gift_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque un barco es mejor que unos calcetines. Elige el nivel de tu marinero y deja que navegue cuando quiera.`)
};

const gl_gift_hero_lead = /** @type {(inputs: Gift_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque un barco é mellor que uns calcetíns. Elixe o nivel do teu mariñeiro e deixa que navegue cando queira.`)
};

const en_gift_hero_lead = /** @type {(inputs: Gift_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Because a boat beats socks. Pick your sailor's level and let them sail when they want.`)
};

/**
* | output |
* | --- |
* | "Because a boat beats socks. Pick your sailor's level and let them sail when they want." |
*
* @param {Gift_Hero_LeadInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gift_hero_lead = /** @type {((inputs?: Gift_Hero_LeadInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_Hero_LeadInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gift_hero_lead(inputs)
	if (locale === "en") return en_gift_hero_lead(inputs)
	return es_gift_hero_lead(inputs)
});